// src/pages/Home.jsx
import "../assets/stylesheets/home.css";
import { useEffect, useState } from "react";
import { app } from "../firebaseInit"; // if needed
import { getFirestore, collection, getDocs } from "firebase/firestore";

const db = getFirestore();

export default function Home() {
  const [playstates, setPlaystates] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchPlaystates = async () => {
      setLoading(true);
      try {
        const snap = await getDocs(collection(db, "playstates"));
        const states = snap.docs.map((doc) => ({
          uid: doc.id,
          ...doc.data(),
        }));
        setPlaystates(states);
      } catch (err) {
        console.error("Failed to fetch playstates:", err);
      } finally {
        setLoading(false);
      }
    };

    fetchPlaystates();

    // Optional: poll every 5s for live updates
    const interval = setInterval(fetchPlaystates, 5000);
    return () => clearInterval(interval);
  }, []);

  return (
    <>
      <section className="main-page page-heading">
        <h1>Welcome To Sharify</h1>
      </section>

      {loading && playstates.length === 0 ? (
        <p className="main-page-subtext">Loading...</p>
      ) : playstates.length === 0 ? (
        <p className="main-page-subtext">Nobody is listening right now...</p>
      ) : null}

      <main className="main-page profile-grid" id="profile-grid">
        {playstates.map((playstate) => {
          const track = playstate.track;
          if (!track) return null;

          const progressPercent =
            track.trackProgressMs && track.trackDurationMs
              ? (track.trackProgressMs / track.trackDurationMs) * 100
              : 0;

          return (
            <div key={playstate.uid} className="trackContainer">
              <div className="trackCover">
                <img
                  src={track.trackImage}
                  alt={`${track.trackName} album cover`}
                  className="trackImage"
                />
                <div className="trackText">
                  <div className="trackName">{track.trackName}</div>
                  <div className="trackArtists">
                    {track.trackArtists?.join(", ")}
                  </div>
                </div>
              </div>

              <div className="trackProgressBackground">
                <div
                  className="trackProgress"
                  style={{ width: `${progressPercent}%` }}
                ></div>
              </div>
            </div>
          );
        })}
      </main>
    </>
  );
}
